<template>
<div class="cennert_bg" >
    <div class="cennert_op"></div>
    <div class="index_cennert">
      <h2>3D建模案例</h2>
      <div class="desc">360°无死角展示，拥有真实视觉体验</div>
<div data-aos="fade-up">
      <div class="cennert">
        <ul class="connert_left">
          <li 
            v-for="(item,index) in data" :key="index"
            @mouseover="mouseOver(index)"
            >
            <h4 :class="{Left_tip:img==index}">{{item.text}}</h4>
          </li>
        </ul>
        <div class="connert_right">
            <div class="connert_right_top">
                <div class="right_top_pop1" @click="changeName(data[img].link_[0])">
                     <img :src="data[img].imag[0]"/>
                    <div class="box_txt">
                           <p>{{data[img].text_h2[0]}}</p>
               
                    </div>
                </div>
                <div class="right_top_pop2" @click="changeName(data[img].link_[1])">
                      <img :src="data[img].imag[1]"/>
                    <div class="box_txt">
                        <p>{{data[img].text_h2[1]}}</p>
                    </div>
                </div>
            </div>
            <div class="connert_right_bottom">
                <ul class="bottom_list">
                    <li @click="changeName(data[img].link_[2])">
                        <img :src="data[img].imag[2]"/>
                         <div class="box_txt">
                            <p>{{data[img].text_h2[2]}}</p>
                          </div>
                    </li>
                    <li @click="changeName(data[img].link_[3])">
                        <img :src="data[img].imag[3]"/>
                         <div class="box_txt">
                          <p>{{data[img].text_h2[3]}}</p>
                         </div>
                    </li>
                    <li @click="changeName(data[img].link_[4])">
                        <img :src="data[img].imag[4]"/>
                         <div class="box_txt">
                              <p>{{data[img].text_h2[4]}}</p>
                         </div>
                    </li>
                </ul>
            </div>
        </div>
        </div>
      </div>
   
      <div class="application">
          <h2>行业应用</h2>
          <div class="desc">场景营销体验必备，展示更多可能</div>
      </div>

      </div>
  </div>

 
</template>
<script>
export default {
    data() {
        return {
            data:[
                  {
                    text:"3D产品展示",
                    imag:['','','','',''],
                    text_h2:["","","","",""],
                    link_:[
                            {
                                Model_link:4,
                                codeid:"",
                                linkcmd:"",
                                bs:1
                            },
                            {
                                Model_link:4,
                                codeid:"",
                                linkcmd:"",
                                bs:1
                            },
                            {
                                Model_link:4,
                                codeid:"",
                                linkcmd:"",
                                bs:1
                            },
                            {
                                Model_link:4,
                                codeid:"",
                                linkcmd:"",
                                bs:1
                            },
                            {
                                Model_link:4,
                                codeid:"",
                                linkcmd:"",
                                bs:1
                            },
                        ]
                }
            ],
            img:""
        }
    },
    methods:{
        mouseOver(index){
            this.img = index
        },
    // 将我的数据传给父组件再由父组件传参给弹窗也就是cases.vue
        changeName(link_){
          if(link_.codeid == '' ){
                return false
            }else{
               
                if(link_.bs==1){
                    if(link_.linkcmd == null ||link_.linkcmd == ''){
                        return false
                    }else{
                        this.$emit('handleChange', link_) // 触发父组件中handleChange事件并传参Jack
                    }
                }else{
                    this.$emit('handleChange', link_) // 触发父组件中handleChange事件并传参Jack
                }   
               
            }
        },
        // 线上展厅案例此处封装
        Exhibition_hall(cate2){
               this.$axios.post(
                        "https://www.3dyunchuang.com/api/test/GetCateInfo2",
                        this.$qs.stringify({
                             cate:4,
                             page:1         
                        }),    
                        )
                        .then(res => {   
                                    this.img = 0
                                    this.data[0].imag[0]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[0].img+'.'+res.data.data[0].type
                                    this.data[0].imag[1]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[1].img+'.'+res.data.data[1].type
                                    this.data[0].imag[2]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[2].img+'.'+res.data.data[2].type
                                    this.data[0].imag[3]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[3].img+'.'+res.data.data[3].type
                                    this.data[0].imag[4]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[4].img+'.'+res.data.data[4].type
                                    //文字
                                    this.data[0].text_h2[0] = res.data.data[0].title
                                    this.data[0].text_h2[1] = res.data.data[1].title
                                    this.data[0].text_h2[2] = res.data.data[2].title
                                    this.data[0].text_h2[3] = res.data.data[3].title
                                    this.data[0].text_h2[4] = res.data.data[4].title
                                    // id
                                    this.data[0].link_[0].codeid = res.data.data[0].ID
                                    this.data[0].link_[1].codeid = res.data.data[1].ID
                                    this.data[0].link_[2].codeid = res.data.data[2].ID
                                    this.data[0].link_[3].codeid = res.data.data[3].ID
                                    this.data[0].link_[4].codeid = res.data.data[4].ID      

                                    this.data[0].link_[0].linkcmd = res.data.data[0].link
                                    this.data[0].link_[1].linkcmd = res.data.data[1].link
                                    this.data[0].link_[2].linkcmd = res.data.data[2].link
                                    this.data[0].link_[3].linkcmd = res.data.data[3].link
                                    this.data[0].link_[4].linkcmd = res.data.data[4].link    
                        })
        },
    },
    mounted(){
         //传展示什么类型
        this.Exhibition_hall("产品")   
    },
}
</script>
<style scoped>

ul,li{
    list-style: none;
}
.cennert_bg{
    width: 100%;
    height: 888px;
    background: #142443;
    position: relative;
}
.cennert_op{
    width: 100%;
    height: 100%;
    background: url("../../assets/imges/scheme/cennert_bg.png");
    background-size: 100% 100%;
    opacity: 0.1;
    position: absolute;
    left: 0;
    top: 0;
}

.index_cennert{
    width: 1202px;
    margin: 0 auto;
    position: relative;
    z-index: 9;
}
.index_cennert h2{
    padding-top: 63px;
    text-align: center;
    color: #fff;
    font-weight: 400;
    font-size: 36px;
    font-weight: bold;
}
.desc{
    padding-top: 12px;
    padding-bottom: 60px;
    font-size: 18px;
    color: #ffffff;
    text-align: center
}
.connert_left{
    float: left;
    height: 574px;
    background-color: #2e353e;
    background: #1a2e56;
}
.connert_left li{
    line-height: 75px;
    color: #fff;
    width: 148px;
    height: 75px;
    text-align: center;
    font-size: 14px;
    position: relative; 
}
.connert_left li h4{
    font-weight: normal;
}

.connert_right{
    width: 1031px;
    float: right;
    height: 574px;
}
.detailed_footer h4{
    font-size: 16px;
    margin-top: 36px;
    color: #989a99;
    font-weight: normal;
}
.connert_right_top{
    width: 100%;
    height: 333px;
    margin-bottom: 20px;
}
.connert_right_bottom{
    width: 100%;
    height: 220px;
}
.right_top_pop1{
    width: 504px;
    height: 100%;
    float: left;
    position: relative;
    overflow: hidden;
}
.right_top_pop2{
    width: 504px;
    height: 100%;
    float: right;
    position: relative;
    overflow: hidden;
}
.bottom_list{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content:space-between
}
.bottom_list li{
    width: 327px;
    height: 100%;
    position: relative;
    overflow: hidden;
}
.box_txt{
    position: absolute;
    bottom: 0px;
    left: 0px;    
    height: 42px;
    width: 100%;
    background: rgba(25,25,25,.5);
    line-height: 42px;
    color: #fff;
}
.box_txt p{
    margin-left: 20px;
    font-size: 14px;
}
.right_top_pop1 img{
    width: 100%;
    height: 100%;
}
.Left_tip{
    position: absolute;
    left: -12px;
    top: 0;
    width: 191px;
    height: 68px;
    background: url("../../assets/imges/hy_lef.png") no-repeat  !important;
    background-size:100% 100%;
    cursor: pointer;
    font-weight: bold!important;
    transition: 0.5s all;
    z-index: 9;
}
.connert_right img{
    width: 100%;
    height: 100%;
    transition: 1s all;
    cursor: pointer;
}
.connert_right img:hover{
    transform: scale(1.2);
}
.mobile_terminal{
    width: 100%;
    height: 170px;
    -webkit-box-shadow: 0px 2px 0 rgba(0,0,0,.1);
    border-radius: 0 0 2px 2px;
    display: none;
}
.mobile_terminal ul{
    width: 100%;
    height: 100%;
    display: flex;
}
.mobile_terminal ul li{
    flex: 1;
    height: 184px;
    text-align: center;
}
.mobile_terminal ul li div{
    width: 100%;
    text-align: center;
    height: 50px;
    margin-bottom: 10px;
}
.mobile_terminal ul li div img{
    width: 50px;
    height: 50px;
}
.mobile_terminal ul li p{
    color: #333;
    font-size: .22rem;
    font-weight: 500;
    margin-bottom: .16rem;
}
.mobile_terminal ul li span{
    color: #333;
    font-size: .22rem;
    font-weight: 500;
    margin-bottom: .16rem;
}
.application{
    width: 100%;
    height: 100px;
    display: none;
}
.products{
    width: 100%;
    height: 230px;
    display: none;
}
.swiper-container{
    width: 95%;
    height: 200px;
}
.swiper-container img{
    width: 100%;
    height: 100%;
}
#swiper-text{
    color: #fff;
    height: 25px;
    position: absolute;
    z-index: 9999999;
    left: 50%;
    bottom: 20px;
    width:70px;
    border:1px solid #fff;
    border-radius: 10px;
    text-align: center;
    line-height: 25px;
    margin-left: -28px;
    font-weight: normal;
    font-size: 14px;
}
.connert_left li:last-of-type:after{
    height: 0;
}
.connert_left li:after {
    content: "\0020";
    display: block;
    height: 1px;
    background: #334569;
    overflow: hidden;
    width: 24px;
    transition: 0.5s all;
    position: absolute;
    left: 50%;
    bottom: 7px;
    transform: translateX(-50%);
}
</style>





// WEBPACK FOOTER //
// src/common/modeling/modeling-model.vue